import { createAction, props } from '@ngrx/store';
import { CommodityFieldList } from '../_models/irrigation_v2';
import { GetIrrigationAdviceParams } from '../_models/irrigation_v2/irrigationServiceParams';

// Action types
export const loadIrrigationAdvice = createAction(
  '[IrrigationAdvice] Load IrrigationAdvice',
  props<{ irrigationSupplyGetParams: GetIrrigationAdviceParams }>()
);
export const loadIrrigationAdviceSuccess = createAction(
  '[IrrigationAdvice] Load IrrigationAdvice Success',
  props<{ commodities: CommodityFieldList[]; calculationEnabled?: boolean }>()
);
export const loadIrrigationAdviceFailure = createAction(
  '[IrrigationAdvice] Load IrrigationAdvice Failure',
  props<{ error: any }>()
);
